import home from '@/pages/home.vue'
import login from '@/pages/login.vue'
import dashboard from '@/pages/dashboard.vue'
import dianpu from '@/pages/dianpu/index.vue'
import goodsspec from '@/pages/goods/spec.vue'
import kuaidimoban from '@/pages/kuaidi/moban.vue'
import kuaidirule from '@/pages/kuaidi/rule.vue'
import goodslist from '@/pages/goods/list.vue'
import writecopy from '@/pages/goods/writecopy.vue'
import orderlist from '@/pages/order/list.vue'
import chaidan from '@/pages/order/chaidan.vue'
import tixian from '@/pages/caiwu/tixian.vue'
import prospec from '@/pages/goods/prospec.vue'
import orderlist1 from '@/pages/order/list1.vue'
import advertype from '@/pages/advert/advertype.vue'
import adver from '@/pages/advert/adver.vue'
import slide from '@/pages/advert/slide.vue'
import zhuanti from '@/pages/advert/zhuanti.vue'
import huiyuan from '@/pages/user/huiyuan.vue'
import admin from '@/pages/system/admin.vue'
import keyword from '@/pages/system/keywords.vue'
import brand from '@/pages/goods/brand.vue'
import firstmenu from '@/pages/goods/firstmenu.vue'
import secmenu from '@/pages/goods/secmenu.vue'
import indexcategory from '@/pages/goods/indexcategory.vue'
import caigou from '@/pages/caigou/index.vue'
import kucun from '@/pages/goods/kucun.vue'
import movingpin from '@/pages/goods/movingpin.vue'
import distristatics from '@/pages/order/distristatics.vue'
import partnerbrand from '@/pages/order/partnerbrand.vue'
import spider from '@/pages/system/spider.vue'
import shopcar from '@/pages/goods/shopcar.vue'
import monitor from '@/pages/goods/monitor.vue'

let routes = [
  {
    path: '/login',
    component: login,
    hidden: true
  },
  {
    path: '/',
    component: home,
    name: '首页',
    iconCls: 'fa fa-address-card',
    leaf: false,
    children: [
      { path: '/', component: dashboard, name: '首页' }
    ]
  },
  {
    path: '/',
    component: home,
    name: '店铺管理',
    iconCls: 'fa fa-address-card',
    leaf: false,
    children: [
      { path: '/dianpu', component: dianpu, name: '店铺管理' }
    ]
  },
  {
    path: '/',
    component: home,
    name: '广告管理',
    iconCls: 'fa fa-address-card',
    leaf: false,
    children: [
      { path: '/adver', component: adver, name: '广告' },
      { path: '/zhuanti', component: zhuanti, name: '专题' },
      { path: '/advert/advertype', component: advertype, name: '场景' },
      { path: '/slide/:id', component: slide, name: '幻灯片', hidden: true }

      
    ]
  },
    {
    path: '/',
    component: home,
    name: '采购管理',
    iconCls: 'fa fa-address-card',
    leaf: false,
    children: [
      { path: '/caigou/index', component: caigou, name: '采购记录' },
    ]
  },
   
  {
    path: '/',
    component: home,
    name: '商品管理',
    iconCls: 'fa fa-address-card',
    leaf: false,
    children: [
      { path: '/goods/brand', component: brand, name: '品牌' },
      { path: '/goods/indexcategory', component: indexcategory, name: '首页分类' },
      { path: '/goods/firstmenu', component: firstmenu, name: '一级分类' },
      { path: '/goods/secmenu', component: secmenu, name: '二级分类' },
      { path: '/goods/specification', component: goodsspec, name: '商品规格' },
      { path: '/goods/prospec/:proid', component: prospec, name: '商品规格', hidden: true },
            { path: '/goods/list', component: goodslist, name: '商品列表' }
    ]
  },
 {
    path: '/',
    component: home,
    name: '数据管理',
    iconCls: 'fa fa-address-card',
    leaf: false,
    children: [
         { path: '/shopcar', component: shopcar, name: '购物车' },
        // { path: '/monitor', component: monitor, name: '订阅管理' },
        { path: '/goods/movingpin', component: movingpin, name: '商品罗盘' },
        { path: '/goods/kucun', component: kucun, name: '库存警告' }
        // { path: '/writecopy', component: writecopy, name: '文案管理' }
    ]
  },
  {
    path: '/',
    component: home,
    name: '订单管理',
    iconCls: 'fa fa-address-card',
    leaf: false,
    children: [
      { path: '/order/list', component: orderlist, name: '订单列表' },
      { path: '/order/distristatics', component: distristatics, name: '分销罗盘' },
      { path: '/order/partnerbrand', component: partnerbrand, name: '品牌合伙' },
      { path: '/order/list1', component: orderlist1, name: '退货订单' },
      { path: '/order/list/:usid', component: orderlist, name: '订单列表', hidden: true },
      { path: '/order/list/:usid/:orderNum', component: orderlist, name: '订单列表', hidden: true },
      { path: '/order/chaidan/:orderNum', component: chaidan, name: '订单列表', hidden: true }
    ]
  },
  {
    path: '/',
    component: home,
    name: '快递管理',
    iconCls: 'fa fa-address-card',
    leaf: false,
    children: [
      { path: '/kuaidi/moban', component: kuaidimoban, name: '快递模板' },
      { path: '/kuaidi/rule', component: kuaidirule, name: '快递规则' }
    ]
  },
  {
    path: '/',
    component: home,
    name: '用户管理',
    iconCls: 'fa fa-address-card',
    leaf: false,
    children: [
      { path: '/user/huiyuan', component: huiyuan, name: '会员管理' }
    ]
  },
  {
    path: '/',
    component: home,
    name: '财务管理',
    iconCls: 'fa fa-address-card',
    leaf: false,
    children: [
      { path: '/tixian', component: tixian, name: '账户提现' }
    ]
  },
  {
    path: '/',
    component: home,
    name: '系统管理',
    iconCls: 'fa fa-address-card',
    leaf: false,
    children: [
      { path: '/user', component: admin, name: '管理员' },
      { path: '/keyword', component: keyword, name: '关键词' },
      { path: '/spider', component: spider, name: '爬虫库' }
      
    ]
  }
];
export default routes;



// WEBPACK FOOTER //
// ./src/router/index.js